// extracted by mini-css-extract-plugin
export default {"socialNetworks":"KSpe8SpbP8GI5nMDcneIM"};